@if(pet()) {
<app-pet-modal
  [(isOpen)]="isModalOpen"
  [isDelete]="true"
  [pet]="pet()"
  (success)="redirectRoute()"
/>
<div class="fixed bottom-4 right-4 z-50">
  <button
    type="button"
    (click)="onOpenModal()"
    [disabled]="isLoading()"
    class="group flex cursor-pointer items-center overflow-hidden rounded-full bg-red-500 text-white shadow-lg transition-all duration-300 hover:bg-red-400 disabled:bg-gray-400 hover:scale-105"
  >
    <div class="p-4">
      <fa-icon [icon]="trashIcon"></fa-icon>
    </div>
    <span
      class="whitespace-nowrap max-w-0 opacity-0 group-hover:max-w-xs group-hover:mr-4 group-hover:opacity-100 transition-all duration-300"
    >
      Excluir Pet
    </span>
  </button>
</div>
}
<app-card
  [title]="pet()?.name || 'Pet'"
  class="lg:w-2/3"
  styleClass="mb-4 lg:mb-0"
>
  <div class="flex items-center w-full mb-4">
    @if(pet()?.qrcodeId){
    <div
      class="text-4xl text-green-500"
      pTooltip="O pet está vinculado a um QRCode!"
      tooltipEvent="hover"
      tooltipPosition="right"
    >
      <fa-icon
        [icon]="shieldIcon"
        animation="flip"
        style="--fa-animation-duration: 3s"
      ></fa-icon>
    </div>
    }
    <div class="ml-auto flex">
      <p
        [ngClass]="{
          'text-red-500': isEditable(),
          'text-gray-400': !isEditable()
        }"
        class="font-semibold mr-2"
      >
        {{ isEditable() ? "Cancelar" : "Editar" }}
      </p>
      <p-toggleswitch [(ngModel)]="isEditable" />
    </div>
  </div>
  <app-pet-form
    [(isLoading)]="isLoading"
    [(enabled)]="isEditable"
    [initialData]="pet()"
    (onSubmit)="updatePet($event)"
  />
</app-card>
